import React from 'react'
import IndustrySector from '../industryComponents/IndustrySector'
import IndustryDesign from '../industryComponents/IndustryDesign'
import HomeTab from '../../home/HomeTab'
import HomeResource from '../../home/HomeResource'
import SustainabilityBanner from '../../sustainability/SustainabilityBanner'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import IndustryInvest from '../industryComponents/IndustryInvest'
import IndustryServe from '../industryComponents/IndustryServe'

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Industries",
  },
  {
    slug: "",
    page: "Healthcare Services",
  },
];

const bannerData = {
  img:"assets/images/healthcare-industry-banner.webp",
  leftHead:"Healthcare Services",
  rightHead:"Bringing Structure and Security to Healthcare Information",
  desc:"In the healthcare sector, accuracy, confidentiality, timely access to information are critical. Dox and Box enables healthcare providers to manage patient records and critical documents with precision, ensuring secure storage, streamlined workflows, instant retrieval to support better clinical and administrative outcomes."
}

const sectorData ={
  head:"Sector Overview",
  overview:"Healthcare organizations operate in a highly regulated environment where managing sensitive patient data, medical records, administrative documents requires strict compliance and robust security. Dox and Box delivers secure, scalable, compliance-ready solutions that help healthcare providers improve operational efficiency, enhance data governance, ensure seamless access to critical information."
}

const designData = {
  head:"Tailored Solutions for Healthcare",
  img:"/assets/images/healthcare-industry-design.webp",
  desc:[
    "We specialize in delivering structured and secure document management systems designed to meet the complex needs of healthcare environments. Our solutions ensure that every record is organized, accessible, aligned with regulatory and operational requirements.",
    "With a deep understanding of healthcare workflows, we help organizations reduce manual effort, improve turnaround times, maintain better control over critical information.",
  ],
  list:[
    "Reliable storage for medical files and patient documentation",
    "Permission-driven access to safeguard confidential healthcare data",
    "Rapid retrieval of patient and treatment information",
    "Regulation-aligned healthcare records management solutions",
    "Intelligent workflow automation for clinical and back-office operations",
    "Flexible platforms designed for expanding healthcare networks",
  ]
}

const tabData = [
  {
    icon: "/assets/images/home-tab-icon-1.webp",
    title: "Physical Records & Archive Management",
    heading:"Secure, Structured, Scalable Physical Record Storage",
    desc:"Managing physical documents doesn’t have to mean cluttered offices or lost files. At Dox and Box, we offer end-to-end physical records management designed to keep your documents secure, accessible, fully compliant. Our state-of-the-art archival facilities are built with strict security protocols, environmental controls, fire safety systems.",
    slug:"/physical-records-management-services",
    image:"/assets/images/home-tab-image-1.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-2.webp",
    title: "Scanning & Digitization Services",
    heading:"Transform Paper Documents into Searchable Digital Assets",
    desc:"Move beyond manual paperwork with high-precision scanning and digitization services. We convert your physical records into structured, searchable, easily accessible digital formats. Using advanced scanning technology and intelligent indexing, we ensure every document is accurately captured and categorized.",
    slug:"/digitization-services",
    image:"/assets/images/home-tab-image-2.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-3.webp",
    title: "Intelligent Document Processing & AI-driven Extraction",
    heading:"Unlock Data from Documents with AI-Powered Intelligence",
    desc:"Turn unstructured documents into actionable data with our AI-driven document processing solutions. We leverage advanced technologies like machine learning, OCR, natural language processing to extract, classify, validate information automatically. From invoices and contracts to forms and reports, our system reduces manual effort, minimizes errors, accelerates workflows. ",
    slug:"/ai-document-data-extraction",
    image:"/assets/images/home-tab-image-3.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-4.webp",
    title: "Data Governance & Compliance Platform (SaaS)",
    heading:"Ensure Compliance, Control, Visibility Across Your Data",
    desc:"In today’s regulatory landscape, managing data securely and compliantly is critical. Our SaaS-based data governance platform provides centralized control over your documents, ensuring they are stored, accessed, managed in line with industry regulations. With role-based access, audit trails, retention policy automation, businesses gain complete visibility and control over their data.",
    slug:"/data-privacy-governance-compliance-platform",
    image:"/assets/images/home-tab-image-4.webp"
  },
]

const investData = {
  head:"Why Healthcare Organizations Need Smart Document Management?",
  boxes:[
    {
      img:'/assets/images/healthcare-industry-invest-1.webp',
      icon:"/assets/images/healthcare-industry-invest-icon-1.webp",
      title:"Enhanced Data Security",
      desc:"Protect sensitive patient information with advanced security and controlled access.",
    },
    {
      img:'/assets/images/healthcare-industry-invest-2.webp',
      icon:"/assets/images/healthcare-industry-invest-icon-2.webp",
      title:"Faster Access to Patient Records",
      desc:"Enable quick retrieval of medical data to support timely and informed care.",
    },
    {
      img:'/assets/images/healthcare-industry-invest-3.webp',
      icon:"/assets/images/healthcare-industry-invest-icon-3.webp",
      title:"Regulatory Compliance",
      desc:"Maintain accurate, audit-ready records aligned with healthcare standards and regulations.",
    },
    {
      img:'/assets/images/healthcare-industry-invest-4.webp',
      icon:"/assets/images/healthcare-industry-invest-icon-4.webp",
      title:"Operational Efficiency",
      desc:"Streamline document workflows to reduce administrative burden and improve productivity",
    },
    {
      img:'/assets/images/healthcare-industry-invest-5.webp',
      icon:"/assets/images/healthcare-industry-invest-icon-5.webp",
      title:"Cost Optimization",
      desc:"Lower storage and operational costs through digitization and automation",
    },
    {
      img:'/assets/images/healthcare-industry-invest-6.webp',
      icon:"/assets/images/healthcare-industry-invest-icon-6.webp",
      title:"Scalable Infrastructure",
      desc:"Adapt seamlessly to increasing patient data and evolving healthcare needs.",
    },
  ]
}

const serveData = {
  head:"Other Industries We Serve",
  boxes:[
    {
      img:"/assets/images/healthcare-industry-serve-1.webp",
      title:"Financial Services",
      desc:"Financial services demand precision, security, seamless access to critical documents.",
      btnText:"Know More",
      slug:"/financial-institutions"
    },
    {
      img:"/assets/images/financial-industry-serve-2.webp",
      title:"Media & Entertainment",
      desc:"Media & Entertainment requires management of digital content and documents, ensuring organized, secure, accessible assets.",
      btnText:"Know More",
      slug:"/media-entertainment-records-management"
    },
  ]
}

export default function Healthcare() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <SustainabilityBanner data={bannerData} />
      <IndustrySector data={sectorData} />
      <IndustryDesign data = {designData}/>
      <HomeTab tabData={tabData}/>
      <HomeResource/>
      <IndustryInvest data = {investData}/>
      <IndustryServe data={serveData}/>
    </>
  )
}
